import React from 'react'
import "../footer/Footer.css"
import { Col, Container, Row } from 'react-bootstrap'
export const Footer = () => {
  return (
    <>
         <section id="footer">
          <Container>
            <Row className='footer-pt' style={{rowGap:'20px'}}>
              <Col lg={3} md={6}>
                <div class="footer-inner">
                  <img src="imeges/desktop 9/Organic white.svg" alt=""/>
                  <div class="footer-inner_main">
                    <div class="footer-inner_main_inco"><i class="fa-solid fa-phone"></i></div>
                    <div class="footer-inner_main_text">
                      <p>Call Us 24/7</p>
                      <h6>(1800)-1088-88</h6>
                    </div>
                  </div>
                  <div class="footer-inner_main">
                    <div class="footer-inner_main_inco"><i class="fa-solid fa-location-dot"></i></div>
                    <div class="footer-inner_main_text">
                      <p>Address</p>
                      <h6>100 Mcevoy st, alexandria <br/>
                        Nsw 2010, Australia</h6>
                    </div>
                  </div>
               </div>
              </Col>
              <Col lg={3} md={6}>
                <div class="footer_main">
                  <h3> Customer Service</h3>
                  <div class="footer_main_inner">
                    <p>Contact us</p>
                    <p>Track your order</p>
                    <p>Return policy</p>
                    <p>Delivery Information</p>
                    <p>Help & FAQ</p>
                    <p>Warranty & Repair</p>
                  </div>
                </div>
              </Col>
              <Col lg={2} md={6}>
                <div class="footer_text">
                  <h3>Categories</h3>
                  <div class="footer_text_text">
                    <p>Fruitls & Vegetables</p>
                    <p>Dairy Products</p>
                    <p>Package Foods</p>
                    <p>Beverage</p>
                    <p>Health & Wellness</p>
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6}>
                <div class="footer_sarch">
                  <h3>Newsletter</h3>
                  <div class="footer_sarch_box">
                    <p>Signup and get a voucher of worth $250.00</p>
                    <form action="./" method="get">
                      <div class="searchbar">
                          <input type="text" class="searchbar__input" name="q" placeholder="Your email address"/>
                          <button type="submit" class="searchbar__button">
                              <i >Send</i>
                          </button>
                      </div>
                    </form>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
  </section>
    </>
  )
}
